let language = {
    410251: "材料映射失败，产品属性异常",
};

export { language }
